// extracted by mini-css-extract-plugin
export var banner = "Banner-module--banner--88bb8";
export var button = "Banner-module--button--5d051";
export var buttons = "Banner-module--buttons--bdf4d";
export var fadein = "Banner-module--fadein--aaf1a";
export var image = "Banner-module--image--d288b";
export var text = "Banner-module--text--e79dc";